import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import CalendarIcon from "@atlaskit/icon/core/calendar";
import LocationIcon from "@atlaskit/icon/core/location";
import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { BlogNewsCard, type BlogNewsCardProps } from "./blog-news-card";

export type BlogEventCardProps = Omit<BlogNewsCardProps, "color" | "label"> & {
    date: string;
    location: string;
};

export const BlogEventCard = (props: BlogEventCardProps) => {
    const { date, location, ...rest } = props;

    const intl = useIntl();

    const eventMeta = (
        <div css={metaRowStyles}>
            <span css={metaItemStyles}>
                <CalendarIcon label="" />
                <span css={metaTextStyles}>{date}</span>
            </span>
            <span css={metaItemStyles}>
                <LocationIcon label="" />
                <span css={metaTextStyles}>{location}</span>
            </span>
        </div>
    );

    return (
        <BlogNewsCard
            {...rest}
            color="blue"
            label={intl.formatMessage({
                id: "BlogEventCard.eventLabel",
                defaultMessage: "Event"
            })}
            eventMeta={eventMeta}
        />
    );
};

const metaRowStyles = css({
    display: "flex",
    flexDirection: "row",
    gap: token("space.250"),
    color: wacToken("color.neutral.light0")
});

const metaItemStyles = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: token("space.075")
});

const metaTextStyles = css({
    fontFamily: wacToken("font.charlie.text"),
    fontWeight: 500,
    color: wacToken("color.neutral.light0"),
    [media.above.lg]: {
        fontSize: "16px",
        lineHeight: "24px"
    },
    fontSize: "14px",
    lineHeight: "20px"
});
